import React, { Component } from 'react';
import { Link } from 'react-router-dom';
import _ from 'lodash';
import { login, loginAccessCode } from '../utils/paymentApi';
import { setAuthToken, setGuestAccessCode } from '../utils/guestStorage';
import { showError } from '../utils/snackbar';
import './Auth.css';

// Optional login: email/password OR Guest Access Code
class Login extends Component {
  constructor(props) {
    super(props);
    this.state = {
      email: '',
      password: '',
      guestAccessCode: '',
      loading: false,
    };
  }

  handleChange = (field) => (event) => {
    this.setState({ [field]: event.target.value });
  };

  handleEmailLogin = async (event) => {
    event.preventDefault();
    try {
      this.setState({ loading: true });
      const result = await login({
        email: this.state.email,
        password: this.state.password,
      });
      setAuthToken(_.get(result, 'token', ''));
      window.location.href = '/profile';
    } catch (e) {
      showError(_.get(e, 'message', 'Login failed'));
    } finally {
      this.setState({ loading: false });
    }
  };

  handleAccessLogin = async (event) => {
    event.preventDefault();
    try {
      this.setState({ loading: true });
      const result = await loginAccessCode(this.state.guestAccessCode.trim());
      setAuthToken(_.get(result, 'token', ''));
      const code = _.get(result, 'guestAccessCode', this.state.guestAccessCode);
      if (code) {
        setGuestAccessCode(code);
      }
      window.location.href = '/profile';
    } catch (e) {
      showError(_.get(e, 'message', 'Login failed'));
    } finally {
      this.setState({ loading: false });
    }
  };

  render() {
    const { email, password, guestAccessCode, loading } = this.state;
    return (
      <div className="auth-page">
        <div className="auth-card">
          <h1 className="auth-title">Log in</h1>
          <p className="auth-sub">Optional — you can still pay as a guest without an account.</p>
          <form onSubmit={this.handleEmailLogin}>
            <label htmlFor="login-email">Email</label>
            <input
              id="login-email"
              type="email"
              value={email}
              onChange={this.handleChange('email')}
              required
            />
            <label htmlFor="login-password">Password</label>
            <input
              id="login-password"
              type="password"
              value={password}
              onChange={this.handleChange('password')}
              required
            />
            <p className="auth-forgot">
              <Link to="/forgot-password">Forgot password?</Link>
            </p>
            <button type="submit" className="auth-cta" disabled={loading}>
              Log in with email
            </button>
          </form>
          <div className="auth-or">or</div>
          <form onSubmit={this.handleAccessLogin}>
            <label htmlFor="login-access">Guest Access Code</label>
            <input
              id="login-access"
              value={guestAccessCode}
              onChange={this.handleChange('guestAccessCode')}
              required
            />
            <button type="submit" className="auth-cta secondary" disabled={loading}>
              Log in with access code
            </button>
          </form>
          <p className="auth-footer">
            New here? <Link to="/signup">Create an account</Link>
          </p>
        </div>
      </div>
    );
  }
}

export default Login;
